module.exports = "<div id=\"go-to-offers-dialog\" class=\"modal-style xl-flexbox xl-center\">\n    <div class=\"modal-in small-screen-overflow\">\n        <div class=\"modal-in__body mobile-padding\">\n            <h3>\n                <span translate>{{$ctrl.title}}</span>\n            </h3>\n            <p translate>{{$ctrl.text}}</p>\n            <span class=\"close-modalB btn btn-primary talep-kapat\" ng-click=\"$ctrl.onClick()\">\n                <span translate>noAuth.otp.offers.button</span>\n            </span>\n        </div>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/no-auth/components/go-to-offers-dialog/go-to-offers-dialog.html
// module id = 466
// module chunks = 0